import React, { ChangeEvent, useEffect, useState } from 'react'
import './styles.css'
import { GuiaMedicoComAgendamento } from '../../../interfaces/entities/GuiaMedicoComAgendamento';
import { aceitaTermoResponsabilidade, buscarGuiaMedicoComAgendamento, getEnfermeirosPlanoMais, getPrestadoresPlanoMais } from '../../../services/SaudeOnlineService';
import { Doctor } from '../../../interfaces/entities/Doctor';
import Filter from './Filter';
import { orderingOptionsDefault } from './defaultStates';
import { FilterInterface } from '../../../interfaces/entities/FilterInterface';
import FilterSelect from '../../../components/FilterSelect';
import { CircularProgress, Pagination } from '@mui/material';
import DoctorsCard from './DoctorsCard';
import { sxPagination } from './sxProps';
import { GuiaMedicoProps } from '../../../interfaces/props/SaudeOnline/GuiaMedicoProps';
import InvalidSearchModal from './InvalidSearchModal';
import { useAccessibility } from '../../../Store/contexts/AccessibilityContext';
import { sxPaginationContrast } from '../../../assets/styles/CommonSxProps';
import { scrollTo } from '../../../utils/ScrollUtil';

function GuiaMedico(props: GuiaMedicoProps) {

  const accessibility = useAccessibility();

  const [doctors, setDoctors] = useState<Doctor[]>([]);
  const [search, setSearch] = useState<GuiaMedicoComAgendamento | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [page, setPage] = useState<number>(1);
  const [orderingOptions, setOrderingOptions] = useState<FilterInterface[]>(orderingOptionsDefault);
  const [invalidSearch, setInvalidSearch] = useState<boolean>(false);

  useEffect(() => {
    getDoctors();
  }, [search]);

  const getDoctors = async () => {
    if (search !== null) {
      setLoading(true)
      const result = await buscarGuiaMedicoComAgendamento(search) as Doctor[];
      if (result !== null) {
        setDoctors(result)
      }
      setLoading(false);
    }
  }

  useEffect(() => {
    if (props.changeDocs) {
      setDoctors(props.docsList)
    }
  }, [props.changeDocs]);

  useEffect(() => {
    setLoading(true)
    setDoctors(props.docsList)
    setPage(1);
    const timer = setTimeout(() => {
      setLoading(false);
    }, 3000);

    return () => clearTimeout(timer);
  }, [props.sortDocs])


  const handleFilter = (value: GuiaMedicoComAgendamento, typeOfAppointment: string) => {
    setSearch(value);
    props.handleTypeOfAppointment(typeOfAppointment)
  }

  const handlePageChange = (event: ChangeEvent<unknown>, newPage: number) => {
    setPage(newPage);
    scrollTo('scroll-ref');
  };

  const paginatedDoctors = doctors.slice(
    (page - 1) * 5,
    page * 5
  );


  const handlePersonalFilter = async (id: string, reference: string, typeOfAppointment: string) => {
    switch (reference) {
      case 'doctor':
        const referralDoctorsResult = await getPrestadoresPlanoMais() as Doctor[];
        const doctor = referralDoctorsResult.find((doc) => doc.idPessoa === id) as Doctor;
        setDoctors([doctor])

        break;
      case 'nurse':
        const referralNursesResult = await getEnfermeirosPlanoMais() as Doctor[];
        if (parseInt(id) > 0) {
          const nurse = parseInt(id) > 0 ? referralNursesResult.find((nurse) => nurse.idPessoa === id) as Doctor : referralNursesResult as any;
          setDoctors([nurse]);
        }else{
          setDoctors(referralNursesResult);
        }
        break;

      default:
        break;
    }
    props.handleTypeOfAppointment(typeOfAppointment)
  }

  const handleSort = (value: string) => {
    props.handleSort(value, doctors)
  }

  const handleSchedule = (doc: Doctor) => {
    props.handleDoctor(doc, doctors);
  }

  const handleInvalidSearch = () => {
    setInvalidSearch(true);
  }

  const handleCloseModal = () => {
    setInvalidSearch(false)
  }

  return (
    <div className='doctors-guide'>
      <Filter userType={props.userType} handleFilter={handleFilter} handlePersonalFilter={handlePersonalFilter} handleInvalidSearch={handleInvalidSearch} />
      <div className="divider" />
      <div id='scroll-ref' />
      <div className="doctors-list">
        <div className="doctors-list-header">
          <div className="doctors-list-header-grid">
            <h1 className='filter-title' style={accessibility.textStyleAccessibility}>Procure seu(a) médico(a)</h1>
          </div>
          <div className="doctors-list-header-grid">
            <h1 className='doctors-sort-title' style={accessibility.textStyleAccessibility}>Ordenar por</h1>

            <div className="doctors-sort">
              <FilterSelect title='' options={orderingOptions} disabled={false} handleChange={handleSort} />
            </div>
          </div>

        </div>
        {loading &&
          <div className="loading-holder">
            <CircularProgress />
          </div>
        }
        {!loading && doctors.length === 0 &&
          <h1 className='empty-notifications' style={accessibility.textStyleAccessibility}>Nenhum profissional foi encontrado. Revise os dados de busca e tente novamente</h1>
        }
        {!loading && doctors.length > 0 &&
          <div className="doctors-cards-list">
            {paginatedDoctors.map((doctor, index) => (
              <DoctorsCard doctor={doctor} handleSchedule={handleSchedule} key={`${doctor.idPessoa}-${index}`} />
            ))}
          </div>
        }
        {doctors.length > 5 &&
          <div className='pagination-holder'>
            <Pagination
              count={Math.ceil(doctors.length / 5)}
              sx={accessibility.contrastMode ? sxPaginationContrast : sxPagination} hideNextButton hidePrevButton
              color='primary'
              page={page}
              onChange={handlePageChange}
            />
          </div>
        }
      </div>
      <InvalidSearchModal handleCloseModal={handleCloseModal} open={invalidSearch} />
    </div>
  )
}

export default GuiaMedico